module.exports = __webpack_public_path__ + "static/media/no-milk.c53225fa.png";